import { WatchQueryFetchPolicy } from '@apollo/client';
import { IsInStorybookEnv } from '../../../constants';

export const getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled = (oid: string) => {
  // fix storybook
  if (IsInStorybookEnv()) {
    return undefined;
  }
  return {
    skip: !oid,
    variables: { oid },
    context: { headers: { 'cache-enabled': 'true' } },
  };
};

export const getStaffUserCurrentQueryOptionsWithOidAndCacheDisabled = (oid: string) => {
  // fix storybook
  if (IsInStorybookEnv()) {
    return undefined;
  }
  return {
    skip: !oid,
    variables: { oid },
    context: { headers: { 'cache-enabled': 'false' } },
    fetchPolicy: 'cache-and-network' as WatchQueryFetchPolicy,
  };
};
